<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <div class="form_title">基本信息</div>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="姓名">
            <a-input :maxLength="30" v-decorator="['userName', rules.userName]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="别名">
            <a-input :maxLength="30" v-decorator="['nickName']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="账号">
            <a-input disabled v-decorator="['userNo']"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="性别">
            <a-radio-group v-decorator="['gender']">
              <a-radio :value="1">男</a-radio>
              <a-radio :value="2">女</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="手机">
            <a-input :maxLength="30" v-decorator="['mobile', rules.mobile]"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="座机">
            <a-input :maxLength="30" v-decorator="['telephone']"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="邮箱">
            <a-input :maxLength="64" v-decorator="['email']"/>
          </a-form-item>
        </a-col>
        <!--        <a-col :span="8">-->
        <!--          <a-form-item label="英文名">-->
        <!--            <a-input :maxLength="64" v-decorator="['userName']"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->

        <a-col :span="8">
          <a-form-item label="部门">
            <a-tree-select
                v-decorator="['deptId',rules.deptId]"
                allow-clear
                :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                :treeData="deptList"
                show-search
                :treeDefaultExpandAll="false"
                :treeDefaultExpandedKeys.sync="defaultExpandedKeys"
                :filterTreeNode="filterTreeNodeOption"
                :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
            >
            </a-tree-select>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="状态">
            <a-input :disabled="true" v-decorator="['statusName']"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="职务">
            <a-input :maxLength="30" v-decorator="['position']"/>
          </a-form-item>
        </a-col>

        <!--        <a-col :span="8">-->
        <!--          <a-form-item label="身份">-->
        <!--            <a-select-->
        <!--                :allowClear="true"-->
        <!--                v-decorator="['catId']"-->
        <!--                :options="[]"-->
        <!--            >-->
        <!--            </a-select>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item label="地址" :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input :maxLength="128" v-decorator="['address']"/>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="头像"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['headImg']" :accept="'image/*'"
                      :url="api.temp.WX_UPLOAD_PATH+'?uploadType=2'"></uploader>
          </a-form-item>
        </a-col>
      </a-row>


      <div class="form_title">对外信息</div>

      <a-row>
        <!--        <a-col :span="8">-->
        <!--          <a-form-item label="企业简称">-->
        <!--            <a-input :disabled="true" v-decorator="['userName']"/>-->
        <!--          </a-form-item>-->
        <!--        </a-col>-->
        <a-col :span="8">
          <a-form-item label="职务">
            <a-input :maxLength="30" v-decorator="['externalPosition']"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-tabs>
      <a-tab-pane key="1" tab="角色" :forceRender="true">
        <roleTable ref="roleTable" :rowId="rowId"></roleTable>
      </a-tab-pane>
    </a-tabs>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">保存</a-button>
      <a-button v-if="!keyId" type="primary" @click="saveAndInvite">保存并发送邀请</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/comm/memberManage';

import roleTable from "@/pages/web/comm/userManage/detail/roleTable";
import {mapState} from "vuex";
import XEUtils from "xe-utils";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    userName: {
      rules: [{required: true, whitespace: true, message: "请输入姓名"}]
    },
    userNo: {
      rules: [{required: true, whitespace: true, message: "请输入账号"}]
    },
    mobile: {
      rules: [{required: true, whitespace: true, message: "请输入手机"}]
    },
    deptId: {
      rules: [{required: true, message: "请选择部门"}]
    },
    defaultExpandedKeys:[]
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  //给子表赋值
  this.$refs['roleTable'].loadData(entity.roleList);
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    gender: 1,
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  let arr = await dataApi.getDeptList();

  this.deptList = XEUtils.toArrayTree(arr.data, {
    key: 'deptId',
    parentKey: 'parentId',
    children: 'children'
  });
  //默认所属部门只展开一级
  this.defaultExpandedKeys = this.deptList.map(val => {
    //默认只展开一级
    if( val.deptId == 1 ){ //已确定测试、正式系统最大一层deptId都是1
      return val.deptId
    }
  })

}

/**
 * 树选择搜索
* */
function filterTreeNodeOption(input, treeNode) {
  return treeNode.data.props.title.includes(input)
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //其他数据处理 类似子表放在这里
  vm.$refs["roleTable"].getChildData((child, del) => {
    entities.roleList = child;
    entities.delRoleIdList = del.map(val => {
      return val.id;
    });
  });

  //子表的数据判断
  let defaultArr = entities.roleList.filter((item) => {
    return item.isMain === 1;
  })
  if (defaultArr.length !== 1) {
    throw '至少且只能选择一个默认角色';
  }

  entities.userId = vm.keyId;
  await dataApi.saveFormDetail(entities);
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    roleTable,
    // roleTableModal
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      deptList: [],
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
    filterTreeNodeOption,
    /**
     * 邀请
     */
    async saveAndInvite() {
      this.formOption.busy = true;

      let data;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {//无任何错误 向下执行
          data = values;
        } else {
          data = null;
        }
      });
      // 必填项未填写完成
      if (!data) {
        this.formOption.busy = false;
        return "必填项未填写完成";
      } else {
        for (let item in data) {
          if (Object.prototype.hasOwnProperty.call(data, item)) {
            //undefined 转 空字符串
            if (data[item] === undefined) {
              data[item] = '';
            }
            //字符串去除前后空格
            if (typeof data[item] === 'string') {
              try {
                if (this.form.formItems[item].$attrs.trim !== false) {
                  data[item] = data[item].trim();
                }
              } catch (e) {
                console.log(e)
              }
            }
            //数组转 ,分隔字符串
            if (data[item] && Array.isArray(data[item])) {
              data[item] = data[item].join(',');
            }
            //布尔转 1 0
            if (typeof data[item] === 'boolean') {
              data[item] = data[item] ? 1 : 0;
            }
          }
        }
      }
      //其他数据处理 类似子表放在这里
      this.$refs["roleTable"].getChildData((child, del) => {
        data.roleList = child;
        data.delRoleIdList = del.map(val => {
          return val.id;
        });
      });

      //子表的数据判断
      let defaultArr = data.roleList.filter((item) => {
        return item.isMain === 1;
      })
      if (defaultArr.length !== 1) {
        this.formOption.busy = false;
        this.$message.error('至少且只能选择一个默认角色');
        return
      }

      data.userId = this.keyId;
      await dataApi.saveFormAndInvite(data).then(() => {
        this.formOption.busy = false;
        this.$message.success('操作成功')
        this.endEdit('saved');
      }).catch(e => {
        this.formOption.busy = false;
        if (e && typeof e.msg === 'string') {
          // this.$message.error(e.msg);
        } else if (e.response?.response?.data?.msg) {
          this.$message.error(e.response.response.data.msg);
        } else {
          this.$message.error('数据保存有误，请联系管理员');
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
</style>